export const homeContents = {
  labels: {
    greeting: (name?: string) => (name ? `Welcome, ${name}` : "Welcome")
  }
};
